import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useIsNative } from "@/hooks/useIsNative";

/**
 * Spec §7 (WEBSITE_redesign_SPEC_for_lovable.md): no browser calling.
 * On web the dialer route is removed from the UX entirely. Native iOS/Android
 * continue to render the real dialer for app calling.
 */
export function BrowserDialerGate({ children }: { children: ReactNode }) {
  const isNative = useIsNative();
  if (isNative) return <>{children}</>;

  return <Navigate to="/connect-portal/dashboard" replace />;
}
